import Vue          from 'vue';
import UspOverview  from './usp-overview.vue';
import Mixins       from '../../mixins/mixin';

Vue.mixin(Mixins);

new Vue({
    el: '#js-usp-overview',
    components: {
        'usp-overview' : UspOverview
    }
});


// WEBPACK FOOTER //
// ./resources/assets/js/frontend/vue/components/usps/usp-overview.js